import { heroMockups } from '../data/landingPageData';
import AppButton from './AppButton';
import PhoneMockup from './PhoneMockup';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero" id="top">
      <div className="hero-copy">
        <span className="eyebrow">A tiny weekly ritual</span>
        <h1>Just gentle proof you still think of each other</h1>
        <p>
          Crumbs is a private weekly ritual for sharing the little moments, thoughts,
          and highlights that keep your people close no matter the distance.
        </p>
        <AppButton />
      </div>
      <div className="hero-visual" aria-label="Crumbs app preview">
        {heroMockups.map((mockup) => (
          <PhoneMockup variant={mockup.phone} tilt={mockup.tilt} key={mockup.phone} />
        ))}
      </div>
    </section>
  );
}

export default HeroSection;
